import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import * as _ from "lodash";

export class ProgramPodGroupComponent implements IController {
  pods: { [key: string]: any };
  title: string;
  help: string;
  translatePrefix: string;
  onPodChange: Function;

  public labels: { [key: string]: string } = {};

  constructor() {
  }

  $onInit() {
    this._computeLabels();
  }

  $onChanges(changes: IOnChangesObject) {
    if (changes.pods || changes.translatePrefix) {
      this._computeLabels();
    }
  }

  handlePodChange(pod) {
    this.onPodChange({pod});
  }

  private _computeLabels() {
    const prefix = this.translatePrefix || '';
    this.labels = _.mapValues(this.pods, (_value, key) => `${prefix}${key}`);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .component('programPodGroup', {
    bindings: {
      pods: '<',
      title: '@',
      help: '@',
      translatePrefix: '@?',
      onPodChange: '&'
    },
    template: require('./program-pod-group.html').default,
    controller: ProgramPodGroupComponent
  });
